<template>
  <div class="main-modal">
    <NavOptions :top="setTop" class="func-modal" :options="options" @clickItem="clickHandler" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { NavOptions } from '@mx/vix';

export default Vue.extend({
  name: 'FuncModal',
  components: {
    NavOptions,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    clickHandler: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      setTop: '',
    };
  },

  mounted() {
    const setHeight = document.querySelector('.title-bar-comp')?.clientHeight;
    if (setHeight) {
      this.setTop = `${setHeight}px`;
    }
  },
});
</script>
<style lang="less" scoped>
.main-modal {
  position: fixed;
  z-index: 50;
  width: 100%;
}
.func-modal {
  padding: 0 0.32rem;
  min-width: 2.2rem;
  width: auto;
  border-radius: 0.12rem;
  background: #ffffff;
  border-radius: 0.16rem;
  box-shadow: 0 0.08rem 0.32rem 0 rgba(0, 0, 0, 0.16);
  right: 0.12rem !important;
  /deep/ .nav-options-item {
    text-align: left;
    height: 0.88rem;
    line-height: 0.88rem;
    padding: 0;
    border: none;
    display: flex;
    align-items: center;
    .nav-options-icon-class {
      display: none;
    }
    .nav-options-icon-url {
      margin-right: 0.08rem;
    }
    .nav-options-text {
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 0.28rem;
      color: #191919;
      letter-spacing: 0;
      line-height: 0.4rem;
      font-weight: 400;
      position: relative;
    }
  }
  /deep/ .nav-options-item:not(:last-child) {
    position: relative;
  }
}
.func-modal::before {
  position: absolute;
  content: ' ';
  display: inline-block;
  width: 0.32rem;
  height: 0.13rem;
  top: -0.11rem;
  right: 0.2rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAAnCAYAAAGHwn16AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAYKADAAQAAAABAAAAJwAAAABD4NsXAAADD0lEQVRoBe2au27UQBSGdyOBEElJ+kShpqGGhh4kUiCeAFqULkLKPgIllDwASNCnoUZIPAGINlRRgrgIyHe8a8c7OzePM/aM4yOdtT1zLv9/jsdre3cyaShTnf1/pByfIuW+bJcOZKBuLMcidaclB53x3OXcqXDA8JSJ6+WkZfvOMuc5RbaZQBNxumBTGRceNiedsdaJwTvlhMf2phNmaUCw3XrAcrz1lqArdbiQRK7A9SSy780E2y/i0EJu1ZNNJVB9YLj7SslOfJkurX6Tk6mM9cuIydeZwBS8DOhKYk3gCu6TxJjAN7griTZB0+C2JCsJQoObkqwRcB19JoFFSsPQ7TxK8flIYuS7kuGwh35Df6OH6E5oVTrzA6T1q4P5QjoD5JsIVF7AF/irjW/8aHahwCsGi51oAE2BLwp450RiAW9DZOVCras6CV4y/kQ3F3nsKl/Gf2w51kyTgD4oK4NNH+AFmlyCRY7RDR3WfL9oFmyMHdCxHcdyqQDn6w4qtw9yDsvtxF4u2CeAPUFN8jBpIibUyvgsSRIKSNdhWiRcaA3zaZAwgPMd7peEL0qHXT8kHKCaTndLoik6T/tuSHiCCTWLSyIUVUO/OCQagmhr7k3C+UADkisT7svRruUVDzNPXUmtBAAv75s/u4JEnP8KiW1bfO3zAMA30OOewQvuLXCIHJhIFB3AQH5RuY0+Rh+YjBMY/wGG5+hH9BPdOR0fKfvuinYN9A3q0uRn7coSsF5JUy9GFmcQRd5GX6N/0Uoo7j/RamC+IzZiu5V68ZPHRxH3UbXADHmL+O4nTzQ1gBQt6OceR1tmqfFMDk+kwqt9GRuhdr6jwo+NSKTwYyN6OuPVwqvHw780JVr44Tcik8IPrxGZFj7/Rgyk8Pk1YqCFj9qI1i+yQHeD28s36F31NnPgxx/gt8tL8e9teAa9jKPom+gL9BfJj9DLVnypuXA+khosarEpg03FuQIIfo2g99D7qPzBR874UcwVkBXxFn2PHrJCfppNc/47vI1VRnNBl6CM+CUPdWxAzy06A26jF2irHjT/AAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 0.32rem 0.13rem;
}
</style>
